import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form/immutable';
import { FormattedMessage } from 'react-intl';
import { injectIntl, intlShape } from 'react-intl';
import Button from '../../../ui/Button';
import Form from '../../../ui/Form';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Input from '../../../ui/Input';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from '../../../ui/Select';
import styles from './css/Address.scss';

/* eslint-disable react/prop-types, react/no-multi-comp */
const renderField = allProps => {

    /* eslint no-unused-vars: ["off", { "ignoreRestSiblings": true }] */
    const { size, ...props } = allProps;

    props.input.id = (props.id || props.input.name);

    return (
        <Form.Control erroneous={!!props.error}>
            {props.label !== false && (
                <Form.Label htmlFor={props.input.name} required={props.required}>
                    <FormattedMessage
                        id={`frontend.form_selector_shipping.label.${props.label || props.input.name}`}
                    />
                </Form.Label>
            )}
            <Input {...props.input} type={props.type} disabled={props.disabled} />
            {props.hint && (
                <Form.Hint>
                    <FormattedMessage id={props.hint} />
                </Form.Hint>
            )}
            <div>
                {props.touched && props.error && <span>{props.error}</span>}
            </div>
        </Form.Control>
    );
};

const renderHiddenField = props => {
    return (
        <input type='hidden' {...props.input}/>
    );
};


@injectIntl
export class UpdateAddressForm extends Component {
/* eslint-enable */
    static propTypes = {
        handleSubmit: PropTypes.func,
        intl: intlShape,
        regions: ImmutablePropTypes.map,
        expandBilling: PropTypes.bool,
        submitting: PropTypes.bool,
    }

    render() {
        const { handleSubmit } = this.props;

        return (
            <Form onSubmit={handleSubmit} noValidate>
                <Field name='id' component={renderHiddenField} />

                {/* Contact */}
                <Form.Fieldset>
                    <h3>
                        <FormattedMessage
                            id='frontend.form_selector_shipping.headline.address'
                        />
                    </h3>
                    <Form.Row>
                        <Field
                            name='address.organization'
                            component={renderField}
                            type='text'
                            hint='frontend.form_selector_shipping.hint.organization'
                            label='organization'
                            disabled
                        />
                    </Form.Row>
                    <Form.Row>
                        <Field
                            name='address.phone'
                            component={renderField}
                            type='text'
                            hint='frontend.form_selector_shipping.hint.phone'
                            label='phone'
                            disabled
                        />
                    </Form.Row>
                    <Form.Row>
                        <Field
                            name='address.email'
                            component={renderField}
                            type='email'
                            label='email'
                            disabled
                        />
                    </Form.Row>
                    <Form.Row>
                        <Field
                            name='address.street'
                            component={renderField}
                            type='text'
                            label='street'
                            disabled
                        />
                    </Form.Row>
                    <Form.Row>
                        <Field
                            name='address.zip'
                            component={renderField}
                            label='zip'
                            type='text'
                            disabled
                        />
                    </Form.Row>
                    <Form.Row>
                        <Field
                            name='address.city'
                            component={renderField}
                            type='text'
                            label='city'
                            disabled
                        />
                    </Form.Row>
                    <Form.Row>
                        <Field
                            component={renderField}
                            disabled
                            label='region'
                            name='address.region'
                            type='text'
                        />
                    </Form.Row>
                </Form.Fieldset>

                {/* Location */}
                <Form.Fieldset>
                    <h3>
                        <FormattedMessage
                            id='frontend.form_selector_shipping.headline.address_details'
                        />
                    </h3>
                    <Form.Row>
                        <Field
                            component={renderField}
                            hint='frontend.form_selector_shipping.hint.location.old_number'
                            label='location.old_number'
                            name='old_number'
                            type='text'
                        />
                    </Form.Row>
                    <Form.Row>
                        <Field
                            name='contact'
                            component={renderField}
                            type='text'
                            required
                            hint='frontend.form_selector_shipping.hint.location.contact'
                        />
                    </Form.Row>

                    <Form.Row>
                        <Field
                            name='floor'
                            component={renderField}
                            type='text'
                            hint='frontend.form_selector_shipping.hint.location.floor'
                        />
                    </Form.Row>

                    <Form.Row>
                        <Field
                            name='info'
                            component={renderField}
                            type='text'
                            required
                            hint='frontend.form_selector_shipping.hint.location.info'
                            label='location.info'
                        />
                    </Form.Row>
                </Form.Fieldset>

                <Button emphasis='primary' type='submit' block>
                    <FormattedMessage id='frontend.form_selector_shipping.button.save' />
                </Button>
            </Form>
        );
    }
}

let FormComponent = reduxForm({
    form: 'address.update',
})(UpdateAddressForm);

const selector = formValueSelector('address.update');
FormComponent = connect((state, props) => ({
    expandBilling: Boolean(selector(state, 'billing.enable')),
    initialValues: props.initialValues,
}))(FormComponent);

// See https://github.com/erikras/redux-form/issues/1010
export default {
    Component: FormComponent,
};
